import { render } from "./WebchatConfigurationTab.vue?vue&type=template&id=8a5d62ee&scoped=true&lang=pug"
import script from "./WebchatConfigurationTab.js?vue&type=script&lang=js&external"
export * from "./WebchatConfigurationTab.js?vue&type=script&lang=js&external"

import "./WebchatConfigurationTab.vue?vue&type=style&index=0&id=8a5d62ee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a5d62ee"]])

export default __exports__